"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classNames = require("classnames");
var I18n = require("i18n-js");
var bind_1 = require("../bind");
var CollapsingFacet = /** @class */ (function (_super) {
    tslib_1.__extends(CollapsingFacet, _super);
    function CollapsingFacet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false,
        };
        return _this;
    }
    CollapsingFacet.prototype.shouldCollapse = function () {
        return this.props.count >= this.props.countThreshold;
    };
    CollapsingFacet.prototype.toggleFacet = function (event) {
        event && event.preventDefault();
        this.setState({ open: !this.state.open });
    };
    CollapsingFacet.prototype.linkText = function () {
        return this.state.open ? 'collapse' : 'showMore';
    };
    CollapsingFacet.prototype.renderToggleLink = function () {
        if (!this.shouldCollapse()) {
            return null;
        }
        return (React.createElement("button", { className: this.props.classPrefix + "__toggle", onClick: this.toggleFacet }, I18n.t("commons.collapsingFacets." + this.linkText())));
    };
    CollapsingFacet.prototype.render = function () {
        var _a;
        var classes = classNames(this.props.classPrefix, (_a = {},
            _a[this.props.classPrefix + "--collapsed"] = this.shouldCollapse() && !this.state.open,
            _a));
        return (React.createElement("div", { className: classes },
            this.props.children,
            this.renderToggleLink()));
    };
    CollapsingFacet.defaultProps = {
        classPrefix: 'facet',
        // this value must match the constant in the
        // `nth-child` selector in `.${classPrefix}__option`
        countThreshold: 6,
    };
    tslib_1.__decorate([
        bind_1.default
    ], CollapsingFacet.prototype, "toggleFacet", null);
    return CollapsingFacet;
}(React.Component));
exports.default = CollapsingFacet;
//# sourceMappingURL=collapsing_facet.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/components/collapsing_facet.js
// module id = Jb8+
// module chunks = 0 1 2 3 4 6 9 10 14 20